import { Refresh } from '@browser/Browser';
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog';
import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue';
import { guid } from '@common/Guid';
import { MonthYear, MonthYearHelpers } from '@common/types';
import { CreateCorporateScenarioCommandV1, UpdateCorporateScenarioCommandV1 } from '@Quest/CorporateScenarios/Domain/commands-core';
import ScenariosCommands from '@Quest/CorporateScenarios/Domain/commands-vue-component';
import ScenariosQueries from '@Quest/CorporateScenarios/Domain/queries-vue-component';
import { SettingsPageReadModel } from '@Quest/CorporateScenarios/Domain/readmodels';
import { ICommandBase } from '@Quest/cqrs';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { CorporateNavigation, MonthPickerDialog } })
export default class SettingsPage extends mixins(ScenariosQueries, ScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }
    get scenarioId() { return this.$route.params.scenarioId ?? null; }

    rm: SettingsPageReadModel | null = null;
    planningStartDateMonthPicker: MonthPickerDialogViewModel = new MonthPickerDialogViewModel();
    planningStartDate: MonthYear | null = null;
    planningStartDateError: string | null = null;

    planningEndDateMonthPicker: MonthPickerDialogViewModel = new MonthPickerDialogViewModel();
    planningEndDate: MonthYear | null = null;
    planningEndDateError: string | null = null;

    benefitsConfidenceDateMonthPicker: MonthPickerDialogViewModel = new MonthPickerDialogViewModel();
    benefitsConfidenceDate: MonthYear | null = null;

    get planningStartDateLabel() { return MonthYearHelpers.toMonthYearLongString(this.planningStartDate); }
    get planningEndDateLabel() { return MonthYearHelpers.toMonthYearLongString(this.planningEndDate); }
    get benefitsConfidenceDateLabel() { return MonthYearHelpers.toMonthYearLongString(this.benefitsConfidenceDate); }


    showPlanningStartDateMonthPicker()
    {
        this.planningStartDateMonthPicker.show(this.planningStartDate, "Start of the Planning horizon", true);
    }

    showPlanningEndDateMonthPicker()
    {
        this.planningEndDateMonthPicker.show(this.planningEndDate, "End of the Planning horizon", true);
    }

    showBenefitsConfidenceDateMonthPicker()
    {
        this.benefitsConfidenceDateMonthPicker.show(this.benefitsConfidenceDate, "End of benefits confidence", false);
    }


    handleSavePortfolioScenarioSettings()
    {
        if (this.rm && this.planningStartDate && this.planningEndDate)
        {
            const portfolioIds = this.rm.Portfolios.filter(p => p.IsConnected === true).map(p => p.PortfolioId);

            if (!this.scenarioId)
            {
                this.invokeCreateCorporateScenarioCommandV1(this.workspaceId, this.strategyId, guid(), this.rm.ScenarioName, this.rm.Description, this.planningStartDate,
                    this.planningEndDate, this.rm.Denomination, this.rm.ApplyBenefitsConfidenceFactor, this.benefitsConfidenceDate, portfolioIds);
            }
            else
            {
                this.invokeUpdateCorporateScenarioCommandV1(this.workspaceId, this.strategyId, this.scenarioId, this.rm.ScenarioName, this.rm.Description, this.planningStartDate,
                    this.planningEndDate, this.rm.Denomination, this.rm.ApplyBenefitsConfidenceFactor, this.benefitsConfidenceDate, portfolioIds);
            }
        }
    }


    mounted()
    {
        document.title = "Enterprise Plan - Settings";
        this.runSettingsPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "SettingsPageReadModel")
        {
            this.rm = model as SettingsPageReadModel;
            this.planningStartDate = this.rm.PlanningStartDate;
            this.planningEndDate = this.rm.PlanningEndDate;
            this.benefitsConfidenceDate = this.rm.BenefitsConfidenceDate;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateCorporateScenarioCommandV1.matchType(cmd))
        {
            location.href = `/#/enterprise-plan/portfolios/${this.workspaceId}/${this.strategyId}/${correlationId}`;
        }
        else if (UpdateCorporateScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }
}